import { createActions, createReducer } from 'reduxsauce'

import ConsultaDespesasPorAcaoOrcamentariaService from '../../servicos/ConsultaDespesasPorAcaoOrcamentariaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaDespesasPorAcaoOrcamentariaInicio: [],
    buscaConsultaDespesasPorAcaoOrcamentariaErro: ['erro'],
    buscaConsultaDespesasPorAcaoOrcamentariaSucesso: ['consultaDespesasPorAcaoOrcamentaria'],
    limpar: [],
    setConsultaDespesasPorAcaoOrcamentariaEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaDespesasPorAcaoOrcamentaria = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaDespesasPorAcaoOrcamentariaInicio())
        let serv = new ConsultaDespesasPorAcaoOrcamentariaService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaDespesasPorAcaoOrcamentariaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaDespesasPorAcaoOrcamentariaErro(error)))
    }
}

const buscaConsultaDespesasPorAcaoOrcamentariaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaDespesasPorAcaoOrcamentariaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaDespesasPorAcaoOrcamentariaSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaDespesasPorAcaoOrcamentaria.resultado,
        dataSincronizacaoDados: action.consultaDespesasPorAcaoOrcamentaria.dataSincronizacaoDados,
        fonte: action.consultaDespesasPorAcaoOrcamentaria.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaDespesasPorAcaoOrcamentariaEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA_INICIO]: buscaConsultaDespesasPorAcaoOrcamentariaInicio,
    [Types.BUSCA_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA_ERRO]: buscaConsultaDespesasPorAcaoOrcamentariaErro,
    [Types.BUSCA_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA_SUCESSO]: buscaConsultaDespesasPorAcaoOrcamentariaSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA_ESTADO_DT]: setConsultaDespesasPorAcaoOrcamentariaEstadoDT,
})
